import t from "react";
/* empty css            */
const i = ({
  children: e
}) => /* @__PURE__ */ t.createElement("div", { className: "rnf-feed-provider" }, e);
export {
  i as NotificationFeedContainer
};
//# sourceMappingURL=NotificationFeedContainer.mjs.map
